import { useCallback, useState } from "react"

import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"
import { Button, Icon, Input, Modal } from "semantic-ui-react"
import styled from "styled-components"

import api from "api"

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1rem;
  min-width: 350px;
  > span {
    display: block;
    margin-bottom: 5px;
    font-weight: 600;
  }
  .ui.input {
    min-width: 350px;
  }
`

export const GatedChallengeModal = ({ closeModal, openModal, challengeName, challengeId, newGroupUsers }) => {
  const { t } = useTranslation()
  const [nextPhaseChallengeName, setNextPhaseChallengeName] = useState(`Next-phase: ${challengeName}`)
  const [nextPhaseGroupName, setNextPhaseGroupName] = useState(`Next-phase group: ${challengeName}`)
  const [isLoading, setIsLoading] = useState(false)

  const createNextPhase = useCallback(() => {
    setIsLoading(true)
    const data = {
      challengeName: nextPhaseChallengeName,
      groupName: nextPhaseGroupName,
      newGroupUsers: newGroupUsers,
    }
    api.authenticatedRequest(
      "POST",
      `/challenges/${challengeId}/gatedChallenge/create`,
      data,
      () => {
        setIsLoading(false)
        toast.success(
          `Next-phase ${t("generic.challenge")}: ${nextPhaseChallengeName}, and group: ${nextPhaseGroupName} created.`,
        )
        closeModal()
      },
      (err) => {
        setIsLoading(false)
        toast.error(err.message)
      },
    )
  })

  return (
    <Modal onClose={closeModal} open={openModal} closeicon>
      <Modal.Header>
        <Icon name="angle double right" />
        Create next-phase (gated) {t("generic.challenge")} based on {challengeName}
      </Modal.Header>
      <Modal.Content>
        <p>
          This will set up a new private group and add the authors (including collaborators) from the selected{" "}
          {t("generic.ideas")} into this group. It will also create a new {t("generic.challenge")} copied from the
          current {t("generic.challenge")} and restrict its availability to the users within the new group.
        </p>
        <p>To continue, please provide a name for the new {t("generic.challenge")} and group.</p>
        <InputContainer>
          <span>New {t("generic.challenge")} name:</span>
          <Input
            defaultValue={nextPhaseChallengeName}
            onChange={(e, { value }) => {
              setNextPhaseChallengeName(value)
            }}
          ></Input>
        </InputContainer>

        <InputContainer>
          <span>New group name:</span>
          <Input
            defaultValue={nextPhaseGroupName}
            onChange={(e, { value }) => {
              setNextPhaseGroupName(value)
            }}
          ></Input>
        </InputContainer>

        <Modal.Actions>
          <Button content={"Cancel"} onClick={closeModal} />

          <Button
            disabled={!nextPhaseChallengeName || !nextPhaseGroupName}
            primary
            loading={isLoading}
            content={"Create next phase"}
            onClick={createNextPhase}
          />
        </Modal.Actions>
      </Modal.Content>
    </Modal>
  )
}
